module.exports = __webpack_public_path__ + "img/icon3.a3d6f3e6.png";